import React, { Component } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';

import './elements/searchable-select.css';
import './elements/searchable-select-user-frontend.css';

class FilteredDropDown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value
    };
  }

  componentWillMount() {
    const { model, dispatch } = this.props;

    dispatch(actions.change(model, this.props.value.value));
    this.setState({ value: this.props.value });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value.value !== nextProps.value.value) {
      this.props.dispatch(actions.change(this.props.model, nextProps.value.value));
      this.setState({ value: nextProps.value });
    }
  }

  handleChange(val) {
    const { model, dispatch } = this.props;

    this.setState({ value: val });

    if (val == null) {
      dispatch(actions.change(model, ''));
    } else {
      dispatch(actions.change(model, val.value));
    }

    if (this.props.onChange && this.props.onChange !== undefined) {
      this.props.onChange(val);
    }
  }

  handleOnInputChange(inputValue) {
    const { onInputChange } = this.props;

    if (onInputChange) {
      return onInputChange(inputValue);
    }

    return inputValue;
  }

  render() {
    const {
      data, placeholder, disabled
    } = this.props;

    return (
      <Select
        className={`${!!window.location.pathname.match('/team/') || !!window.location.pathname.match('/admin/') ? '' : 'form-control'} `}
        onChange={option => this.handleChange(option)}
        onInputChange={inputValue => this.handleOnInputChange(inputValue)}
        options={data}
        placeholder={placeholder}
        value={this.state.value}
        disabled={disabled}
      />
    );
  }
}

export default connect(null)(FilteredDropDown);



// WEBPACK FOOTER //
// ./src/components/common/form/filtered-dropdown.jsx